export default "__VITE_ASSET__PqzRs0iv__"